"use client";

import { logError } from "@faire/web/common/logging";
import { ErrorBoundary } from "react-error-boundary";

export const ErrorBoundaryWithLogging: React.FC<{
  fallback: React.ReactElement | null;
  children: React.ReactNode;
}> = ({ fallback, children }) => {
  return (
    <ErrorBoundary fallback={fallback} onError={(error) => logError(error)}>
      {children}
    </ErrorBoundary>
  );
};
